<template>
  <page-container>
    <template v-slot:page-fixed-header>
      <span class="text-h5 font-weight-bold ml-3 full-width page-header">{{
        $t("menu.statistics&Analysis")
      }}</span>
      <v-spacer></v-spacer>
       <div style="height:40px;"/>
    </template>
    <template v-slot:page-content>
      <UserInfo></UserInfo>
    </template>
  </page-container>
</template>

<script>
import UserInfo from "@/components/statistics/UserInfo.vue";

export default {
  name: "StatisticsAnalysisPage",
  components: {
    UserInfo,
  },
};
</script>

<style scoped>
::v-deep .container--fluid {
  padding: 0px !important;
}
</style>